import { monsters } from '../monsters/monsters-sidecar'
import { distance } from '../lib/distance-sidecar'
import { pathFinder } from '../ui/pathFinder-sidecar'
import { IJob, ITask } from './jobs'
import { jobs } from './jobs-sidecar'
import { jobLogger } from './jobLogger-sidecar'
import { createTask_exitShip } from './taskExitShip'
import { createTask_enterShip } from './taskEnterShip'

export function createTask_moveTo(
  i: number,
  j: number,
  isInsideShip: boolean,
  allowNextTo: boolean,
  onFail: null | (() => boolean) = null,
): ITask {
  return jobs._createTask(i, j, 'move-to', {
    isInsideShip,
    onFail,
    allowNextTo,
  })
}

export function runTask_moveTo(job: IJob, task: ITask) {
  jobLogger.assertTaskType(task, 'move-to')
  let m = jobLogger.assertReserved(job)

  if (jobLogger.runSubtasks(job, task)) {
    return
  }

  if (task.isInsideShip && !m.isInsideShip) {
    // Go inside ship
    task.subtasks.push(createTask_enterShip(m.i, m.j))
    return
  }
  if (!task.isInsideShip && m.isInsideShip) {
    // Go outside ship
    task.subtasks.push(createTask_exitShip(m.i, m.j))
    return
  }

  if (jobLogger.isWaitingForPathOrMovement(job)) {
    return
  }

  if (task.allowNextTo) {
    if (distance.isNextToIJ(m, task)) {
      // We are here!
      return jobLogger.succeedTask(job, task)
    }
  } else {
    if (distance.isAtIJ(m, task)) {
      // We are here!
      return jobLogger.succeedTask(job, task)
    }
  }

  // Find path
  console.log(
    'task move to',
    job.type,
    task.type,
    m.i,
    m.j,
    task.i,
    task.j,
    m.isInsideShip,
  )
  job.findPathId = pathFinder.findPath(
    m.i,
    m.j,
    task.i,
    task.j,
    m.isInsideShip,
    task.allowNextTo,
    (path) => {
      job.findPathId = 0
      jobLogger.assertTask(task)
      if (!path || path.length === 0) {
        return jobLogger.failTask(job, task, 'no path')
      }
      let mPath = jobLogger.assertReserved(job)
      jobLogger.assertTrue(mPath === m, 'monster changed')
      monsters.setPath(mPath, path)
    },
  )
}
